import DocumentRepository from "../domain/data/DocumentRepository";
import Campaign from "../domain/entities/Campaign";
import Document, { DocumentStatus } from "../domain/entities/Document";
import Signatory from "../domain/entities/Signatory";
import User from "../domain/entities/User";
import { SendDocFormInputs } from "../presentation/components/widgets/SendIndvDocumentForm";
import { documents, myDocuments, signatories } from "./InitData";

export default class MockDocumentRepository implements DocumentRepository {
  private static documents: Document[] = documents;
  private static myDocuments: Document[] = myDocuments;
  private static signatories: Signatory[] = signatories;

  async saveDocument(document: Document): Promise<Document> {
    throw new Error("Method not implemented.");
  }
  async saveDocumentRecord(document: Document): Promise<Document> {
    throw new Error("Method not implemented.");
  }
  async saveDocumentAction(document: Document): Promise<Document> {
    throw new Error("Method not implemented.");
  }
  async getDocument(
    signatoryId: string,
    documentId: string
  ): Promise<Document | undefined> {
    return MockDocumentRepository.myDocuments.find(
      (doc) => doc.id === documentId
    );
  }

  async getDocumentExt(shortId: string): Promise<Document | undefined> {
    throw new Error("Method not implemented.");
  }
  
  async sendDocumentIndividual(formData: SendDocFormInputs): Promise<boolean> {
    return true;
  }
  async getDocuments(user: User, campaign: Campaign): Promise<Document[]>;
  async getDocuments(signatory: Signatory): Promise<Document[]>;
  async getDocuments(
    user: User | Signatory,
    campaign?: Campaign | unknown
  ): Promise<Document[]> {
    return MockDocumentRepository.myDocuments;
  }
  async processDocumentStaffbyCampaign(campaign: Campaign): Promise<Document> {
    throw new Error("Method not implemented.");
  }
  async getSignatoryDocuments(
    organizationId: string,
    signatoryId: string,
    downloadFile: boolean
  ): Promise<Document[]> {
    return MockDocumentRepository.myDocuments;
  }
  async signDocument(
    user: User | Signatory,
    organizationId: string,
    documentId: string,
    signedDocument: string,
    formData: string
  ): Promise<string | undefined> {
    const document = await this.getDocument(user.id!, documentId);
    if (document) {
      document.file = signedDocument;
      document.status = DocumentStatus.SIGNED;
      //document.signed = true;
    }
    throw new Error("Method not implemented.");
  }

  async resendDocument(user: User, documentId: string): Promise<{ documentId: string; success: boolean; message?: string }> {
    throw new Error("Method not implemented.");
  }
  async sendBackDocument(user: User, documentId: string, reason: string): Promise<boolean> {
    throw new Error("Method not implemented.");
  }

  async saveDocumentProgress(organizationId: string, documentId: string, reason: string): Promise<boolean> {
    throw new Error("Method not implemented.");
  }

  async externalSignDocument(
    shortId: string,
    signedDocument: string,
    formData: string
  ): Promise<string | undefined> {
    const document = documents[0];
    if (document) {
      document.file = signedDocument;
      //document.signed = true;
    }
    return "signed";
  }

  async getSignatoryByShortId(shortid: string): Promise<Signatory> {
    return MockDocumentRepository.signatories[0];
  }

  async getSignatoryByEmail(email: string): Promise<Signatory> {
    return MockDocumentRepository.signatories[0];
  }

  async getRequestorDocuments(
    organizationId: string,
    requestorId: string
  ): Promise<Document[]> {
    return MockDocumentRepository.myDocuments;
  }
  async downloadPDF(organizationId: string, userId: string, documentId: string): Promise<string> {
    throw new Error("Method not implemented.");
  }
  async downloadPDFwithAuditSummary(organizationId: string, userId: string, documentId: string): Promise<{ signedDocumentPdf: string; auditSummaryPdf: string }> {
    throw new Error("Method not implemented.");
  }
  async translateText(text: string, targetLanguage: string): Promise<any> {
    throw new Error("Method not implemented.");
  }
  async saveAttachment(documentId: string, attachmentId: string, attachmentFile: string): Promise<string> {
    throw new Error("Method not implemented.");
  }
  async getAttachment(documentId: string, attachmentId: string): Promise<string> {
    throw new Error("Method not implemented.");
  }
}
